import axios from "../axios/Config";
import Qs from 'qs';

export const UserService = {

   

        
    registerUser: function (username, password, type, email, phone) {
        return axios.post("/api/registration/addUser", null, { params: { name: username, password: password, type: type, email: email, phone: phone } })
    },
    loginUser: function (username, password, type,  tries){
        return axios.post("/api/validation",null,{params:{name:username,password:password,type: type, cnt: tries, retEntity:true}})
    }
}
